import React, { memo } from 'react'
import Image from 'next/image'
import { pressSYC } from 'vars'
import { FormattedMessage } from 'react-intl'
import Grid from '@mui/material/Grid2'
import useReviews from 'hooks/useReviews'
import RatingCard from 'components/shared/RatingCard'
import Link from '@mui/material/Link'
import RatingCardRow from 'components/shared/RatingCardRow'
import useMediaQuery from '@mui/material/useMediaQuery'
import Typography from '@mui/material/Typography'
import ContainerComponent from 'components/shared/ContainerComponent/ContainerComponent'
import sx from './styles'

const Rating = ({
  sx: sxProp, text, titleMobile = 'SYC_SOLD_VEHICLES_RATING_TITLE', textVariant = 'h3', variant,
}) => {
  const googleReviews = useReviews()
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  const renderPress = (make) => {
    return (
      <Grid
        size={{
          xs: 3,
          md: 1,
        }}
        key={`prensa-${make.name}`}
        sx={sx.item}
      >
        {
          (make.url) ? (
            <Link
              href={`${make.url}`}
              passHref
              target="_blank"
            >
              <Image
                src={make.image}
                alt={make.name}
                fill
                style={{ objectFit: 'contain' }}
                blurDataURL={make.image}
              />
            </Link>
          ) : (
            <Image
              src={make.image}
              alt={make.name}
              fill
              style={{ objectFit: 'contain' }}
              blurDataURL={make.image}
            />
          )
        }
      </Grid>
    )
  }

  return (
    <ContainerComponent
      sx={{
        ...sx.root,
        ...sxProp,
      }}
    >
      {
        variant
          ? (
            <Grid
              sx={sx.gridContainer}
              justifyContent="center"
            >
              <Grid
                sx={sx.gridItemVariant}
                textAlign="center"
                justifyContent="center"
                size={12}
              >
                {
                  isMobile ? (
                    <RatingCardRow
                      rating={googleReviews?.rating ?? 4.5}
                      text={(<FormattedMessage id={titleMobile} />)}
                      sx={sx.rating}
                      showGoogleMapIcon
                    />
                  ) : (
                    <RatingCard
                      sx={sx.ratingContainer}
                      rating={googleReviews?.rating ?? 0}
                      text={text}
                      textVariant={textVariant}
                      vtaVariant
                    />
                  )
                }
              </Grid>
              {
                isMobile && (
                  <Grid size={12}>
                    <Typography
                      sx={sx.title}
                      variant="h3"
                    >
                      {text}
                    </Typography>
                  </Grid>
                )
              }
              <Grid
                container
                size={12}
                justifyContent="space-between"
              >
                {pressSYC?.map(renderPress)}
              </Grid>
            </Grid>
          )
          : (
            <Grid
              sx={sx.gridContainer}
              container
              justifyContent="center"
            >
              <Grid
                sx={sx.gridItem}
                textAlign="center"
                justifyContent="center"
                size={12}
              >
                <RatingCard
                  sx={sx.ratingContainer}
                  rating={googleReviews?.rating ?? 0}
                  text={text}
                  textVariant={textVariant}
                />
              </Grid>
            </Grid>
          )
      }
    </ContainerComponent>
  )
}

export default memo(Rating)
